import { TaxStatusWrapper } from "../../components";

export default function TaxStatusPage() {
  return (
    <>
      <TaxStatusWrapper />
    </>
  );
}
